$('.js-need-translation').on('click', function () {
  $.ajax({
    url: '/api/need_professional_translation',
    data: {
      place: 'repository_list'
    },
    method: 'post',
    dataType: 'json'
  })
})